import ApiService from '@/services/api.service'

const DailyServiceCharge = {
    getAll(parameter, addExtraParams = false) {
      const params = {
        PageSize: parameter.PageSize,
        PageNumber: parameter.PageNumber,
        PatientCode: parameter.PatientCode
      };

      if (addExtraParams) {
        // Add extra params , only for report listing
        params.ProgramCode = parameter.ProgramCode
        params.BillingTherapists = parameter.BillingTherapists
        params.SignedTherapists = parameter.SignedTherapists  
        params.PrimaryInsurances = parameter.PrimaryInsurances;
        params.SecondaryInsurances = parameter.SecondaryInsurances;
        params.Facilities = parameter.Facilities;
        params.DateFrom = parameter.DateFrom; 
        params.DateTo = parameter.DateTo;
        params.TherapiesCode = parameter.TherapiesCode;
        params.NoSecondaryInsurance =  parameter.NoSecondaryInsurance;
        params.UseCategory = parameter.UseCategory;
        params.Show = parameter.Show;
        params.GroupBy = parameter.GroupBy;
        params.DateType = parameter.DateType;
        params.IsSummary = parameter.IsSummary;
        params.IncludeFiltersInReport = parameter.IncludeFiltersInReport;
      }
      return ApiService.getWithArray('/DailyServiceCharge',params); 
    },
}
  
export default DailyServiceCharge;